export default "__VITE_ASSET__BQgg6mxI__"